"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
function flattenExcluding(nodes, excludeSet, depth = 0) {
    const out = [];
    for (const n of nodes) {
        if (excludeSet.has(n.id))
            continue; // skip this node AND its entire subtree
        out.push({ node: n, depth });
        out.push(...flattenExcluding(n.children, excludeSet, depth + 1));
    }
    return out;
}
export function CategoryPicker({ tree, selected, onChange, mode = "multi", excludeIds = [], showCounts = false, }) {
    const [search, setSearch] = useState("");
    const excludeSet = useMemo(() => new Set(excludeIds), [excludeIds]);
    const flat = useMemo(() => flattenExcluding(tree, excludeSet), [tree, excludeSet]);
    const flatById = useMemo(() => new Map(flat.map(({ node }) => [node.id, node])), [flat]);
    function toggle(id) {
        if (mode === "single") {
            onChange(selected[0] === id ? [] : [id]);
            return;
        }
        if (selected.includes(id))
            onChange(selected.filter((x) => x !== id));
        else
            onChange([...selected, id]);
    }
    const filtered = search
        ? flat.filter(({ node }) => node.slug.toLowerCase().includes(search.toLowerCase()) ||
            node.title.toLowerCase().includes(search.toLowerCase()))
        : flat;
    return (_jsxs("div", { className: "flex flex-col gap-3", children: [selected.length > 0 ? (_jsx("div", { className: "flex flex-wrap gap-2", children: selected.map((id) => {
                    const node = flatById.get(id);
                    if (!node)
                        return null;
                    return (_jsxs("button", { type: "button", onClick: () => toggle(id), "aria-label": `Remove ${node.title}`, className: "inline-flex items-center gap-1.5 rounded-pill bg-accent-soft px-2.5 py-1 text-caption font-medium text-accent-deep hover:bg-accent-soft/80", children: [node.title, _jsx("span", { "aria-hidden": "true", children: "\u2715" })] }, id));
                }) })) : null, _jsx("input", { type: "text", placeholder: "Search categories\u2026", value: search, onChange: (e) => setSearch(e.target.value), className: "h-8 rounded-sm border border-ink-200 bg-white px-2 text-body-sm focus:border-accent focus:shadow-focus outline-none" }), _jsx("ul", { className: "max-h-72 overflow-y-auto rounded-sm border border-ink-200", children: filtered.map(({ node, depth }) => {
                    const isSelected = selected.includes(node.id);
                    return (_jsxs("li", { style: { paddingLeft: `${depth * 18 + 12}px` }, className: "flex items-center gap-2 py-1.5 pe-3 hover:bg-paper-warm", children: [_jsx("input", { type: mode === "single" ? "radio" : "checkbox", checked: isSelected, onChange: () => toggle(node.id), "aria-label": node.title }), _jsxs("span", { className: "flex-1 text-body-sm text-ink-900", children: [node.title, _jsx("span", { className: "ms-2 font-mono text-caption text-ink-500", children: node.slug })] }), showCounts ? (_jsxs("span", { className: "text-caption text-ink-500", children: [node.direct_product_count, " prod \u00B7 ", node.child_count, " child"] })) : null] }, node.id));
                }) })] }));
}
